"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.activation.subject': '激活您的账户',
    'email.activation.title': '欢迎来到IntHub！',
    'email.activation.text': '感谢您注册IntHub。要完成注册并激活您的账户，请点击下面的按钮。',
    'email.activation.button': '激活账户',
};
